"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeatureURL = void 0;

var _fullscript = require("../fullscript");

var _fullscriptJsValidator = require("../fullscriptJsValidator");

var _utils = require("../utils");

var _featurePath = require("./featurePath");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getFeatureURL = function getFeatureURL(featureType, featureOptions, fullscriptOptions, frameId) {
  var publicKey = fullscriptOptions.publicKey,
      env = fullscriptOptions.env,
      domain = fullscriptOptions.domain;
  var queryString = (0, _utils.buildQueryString)(_objectSpread(_objectSpread({}, featureOptions), {}, {
    publicKey: publicKey,
    frameId: frameId
  }));
  (0, _fullscriptJsValidator.validateFeatureType)(featureType);
  var fsDomain = domain !== null && domain !== void 0 ? domain : _fullscript.FULLSCRIPT_DOMAINS[env];
  return "".concat(fsDomain, "/api/embeddable/session").concat(_featurePath.FEATURE_PATHS[featureType]).concat(queryString, "&target_origin=").concat(window.location.origin);
};

exports.getFeatureURL = getFeatureURL;